import React, { Children, cloneElement } from 'react'
import { AccordionContext } from './Accordion.style'
import { useAccordion } from './useAccordion'

const Accordion = ({
  component = 'div',
  value,
  callback = () => {},
  children,
  ...others
}) => {
  const { itemOpen, handleCallback } = useAccordion({ value, callback })

  return (
    <AccordionContext as={component} {...others}>
      {Children.map(children, (child, index) => {
        return cloneElement(child, {
          isOpen: itemOpen === index,
          key: index,
          callback: () => handleCallback(index),
        })
      })}
    </AccordionContext>
  )
}

export { Accordion }
